module.exports = __webpack_public_path__ + "img/edit-all.c1167cb5.svg";